class ChangeSendCosts {
	constructor($scope, config) {
		this.config = config;
		this.$scope = $scope;
		this.init();
	}

	init() {
		this.$scope.on('submit', this.config.sendCostsForm, this.changeSendCosts.bind(this));
	}

	changeSendCosts(event) {
		event.preventDefault();
		let $form = $(event.currentTarget);
		let formdata = $form.serializeObject();
		formdata['action'] = 'change_sendcosts';

		showLoader();
		$.ajax({
			url: location.pathname,
			method: 'post',
			data: formdata,
			success: this._onSuccess.bind(this, $form),
			error: (response, a, b) => this._setMessage($form, response.responseJSON.message, 'danger')
		}).always(() => {
			hideLoader();
		});
	}

	_onSuccess($form, response) {
		let order = $form.closest(this.config.details).data('order')
		let $row = $form.closest(this.config.scope).find(`${this.config.toggle}[data-order="${order}"]`);
		let $price = $row.find(this.config.price);
		$price.html(response.price);
		this._setMessage($form, response.message, 'success');
	}

	_setMessage($form, message, level = 'success') {
		this._removeMessage($form).then(() => {
			let $message = $(`<div data-message class="alert alert-${level} mb-0 mt-3" style="display:none">${message}</div>`);
			$form.append($message);
			$message.slideDown();
		});
	}

	_removeMessage($form) {
		return new Promise((resolve) => {
			let $currentMessage = $form.find('[data-message]');
			if ($currentMessage.length < 1) {
				resolve(true);
			}
			$currentMessage.slideUp(400, () => {
				$currentMessage.remove();
				resolve(true);
			});
		});
	}
}

export default ChangeSendCosts;